import { ICON__trash_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_generation from '@/locales/keys/i18n_page_generation.json';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { useTranslation } from 'react-i18next';

interface Props {
  field: FIELD__token;
}

export function G_BUTTON__token_delete({ field }: Props) {
  /*
   * STORE
   */
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { generation_current } = use_slice_generation(['generation_current']);

  const tooltip_title = t(i18n_page_generation.sidebar_user_input.button.token_delete.tooltip);

  let { graph } = generation_current.tool;

  /*
   * EVENTS
   */
  async function onClick() {
    let parent = graph.field__get_parent(field.meta);
    assert_instanceof(parent, FIELD__list_token);

    let parent_new = parent.clone();
    parent_new.item_remove(field);

    let graph_new = graph.clone();
    graph_new.field__replace(parent_new);

    await UTILS__graph_data.update(graph_new);
  }

  /*
   * METHODS
   */
  function is_disabled(): boolean {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */

  if (field.weight.meta.grid2d__is_dimension) return <PLACEHOLDER_BUTTON__bar class_name_button="size-8" />;

  return (
    <UI_PRIMITIVE__tooltip {...{ tooltip_title }}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant="no-border-on-component"
        size="rect-10-8"
        {...{ onClick }}
        disabled={is_disabled()}
        iconClassNameBase="text-component-item-foreground !size-3"
        iconClassNameHovered="!text-bar-foreground"
        Icon={ICON__trash_solid}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
